import * as React from "react";
import type { FC } from "react";
import { createContext, useContext } from "react";

import type { GraphQLClient, GraphQLClientProviderProps } from "./types";

const GraphQLClientContext = createContext<GraphQLClient>({
  request() {
    throw new Error("GraphQLClient not defined");
  },
});

export const useGraphQLClient = (): GraphQLClient =>
  useContext(GraphQLClientContext);

export const GraphQLClientProvider: FC<GraphQLClientProviderProps> = ({
  graphQLClient,
  children,
}) => (
  <GraphQLClientContext.Provider value={graphQLClient}>
    {children}
  </GraphQLClientContext.Provider>
);
